import Image1 from "../assets/images/designTab/Tab button1.jpg";
import Image2 from "../assets/images/designTab/Tab button2.jpg";
import Image3 from "../assets/images/designTab/Tab button3.jpg";
import Image4 from "../assets/images/designTab/Tab button4.jpg";
import Image5 from "../assets/images/designTab/Tab button5.jpg";
import Image6 from "../assets/images/designTab/Tab button6.jpg";
import Image7 from "../assets/images/designTab/Tab button7.jpg";
import Image8 from "../assets/images/designTab/Tab button8.jpg";

export const designTabImages = [Image1, Image2, Image3, Image4, Image5, Image6, Image7, Image8];
